module.exports = __webpack_public_path__ + "static/img/wok.1b7aa68.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wok.gif
// module id = TS+X
// module chunks = 4